<template>
  <div 
    ref="tagAddPopWrap"
    class="tagAddPopWrap" 
    :class="tagAddPopWrapViewBln ? 'active' : null"
    :style="posStyle">
    <button 
      class="addBtn" 
      :class="[ openClass , tagOptionPopListViewBln ? 'spin' : null ]" 
      @click="tagListHandler" 
      ></button>
      <!-- @contextmenu.prevent="tagListHandler"  -->
  </div>
</template>

<script>
import { commNewMapGetters , commNewMapMutations } from "@processEditor/CommNew"; 
import TagAddPopComm from "@TagAddPop/TagAddPopComm"; 
export default {
  mixins:[ TagAddPopComm ] , 
  data () {
    return {
      /* pos : { 
        x : window.innerWidth / 2 , 
        y : window.innerHeight / 2 , 
      } ,  */
      /* viewBln : false ,  */
      openClass : null , 
      timeoutBln : false , 
    }
  } , 
  computed : {
    ...commNewMapGetters([
      'PROCESS_INFO' , 
      'emptyProcess' , 
      'editorProcessMotherElem' , 
      'processEditorElemID' , 
      'pending' , 
      'crntItem' , 
      'crntDiagram' ,
      'getProcessReadOnly' ,
    ]) , 
    posStyle () {
      let size = 0 ; 
      if ( this.$refs.tagAddPopWrap ) {
        size = parseInt( getComputedStyle( this.$refs.tagAddPopWrap , null ).getPropertyValue( '--btn-size' ) ) ; 
      } 
      return {
        left : `${ this.pos.x - size / 2 }px` , 
        top : `${ this.pos.y - size / 2 }px` , 
      }
    } , 
  } , 
  watch : {
    emptyProcess : {
      immediate : true , 
      deep : true , 
      handler ( emptyProcess ) {
        if ( this.emptyProcess ) {
          this.updatePos({ x : window.innerWidth / 2 , y : window.innerHeight / 2 }) ; 
          this.$emit("setPosition", { x : window.innerWidth / 2 , y : window.innerHeight / 2 });
        }
        this.setTagAddPopWrapViewBln({ bln : this.emptyProcess }) ; 
        this.openClass = emptyProcess ? 'open' : null ; 
      } , 
    } , 

    PROCESS_INFO : { // 진입 이벤트 제어  
      handler () {
        this.addTagPopContainerList({ obj : { tagAddPopWrap : this.$refs.tagAddPopWrap }}) ; 
        window.addEventListener( 'contextmenu' , this.openHandler ) ; 
        window.addEventListener( 'click' , this.closeHandler ) ; 
        window.addEventListener( 'popstate' , this.unmountHandler ) ;
      }
    } ,

    getProcessReadOnly : { // 진입 이벤트 제어
      handler () {
        if(!this.getProcessReadOnly){
          this.addTagPopContainerList({ obj : { tagAddPopWrap : this.$refs.tagAddPopWrap }}) ;
          window.addEventListener( 'contextmenu' , this.openHandler ) ;
          window.addEventListener( 'click' , this.closeHandler ) ;
          window.addEventListener( 'popstate' , this.unmountHandler ) ;
        }
      }
    } ,

  } , 
  created () {
  } , 
  mounted () {
  } , 
  methods : {
    ...commNewMapMutations([
      'setEmptyProcess' , 
    ]) , 
    unmountHandler () {
      // console.log( '[ unmountHandler in ]') ; 
      window.removeEventListener( 'contextmenu' , this.openHandler ) ; 
      window.removeEventListener( 'click' , this.closeHandler ) ; 
      window.removeEventListener( 'popstate' , this.unmountHandler ) ;
      // this.setTagAddPopWrapViewBln({ bln : fasle }) ; 
      this.openClass = null ; 
    } , 
    openHandler ( e ) { // 버튼 열기 제어 
      // openClass를 초기화 하고 event 실행.
      this.openClass = null ; 
      if ( this.crntDiagram && this.crntDiagram.selection.size >= 1 ) {
        this.openClass = null ; 
        return ; 
      }
      let { openClass , processEditorElemID } = this ; 
      let motherElem = document.querySelector( processEditorElemID ) ; 
      this.openClass = 'open' ; 
      if ( !motherElem?.contains( e.target ) || openClass != null ) return ; 
      this.updatePos({ x : e.pageX , y : e.pageY });
      this.$emit("setPosition", { x : e.pageX , y : e.pageY });
      this.setTagAddPopWrapViewBln({ bln : true }) ; 
    } , 

    closeHandler ( e ) { // 버튼 닫기 제어 
      let { containerList } = this ; 
      let clickBln = Object.entries( containerList ).some(( [ k , v] ) => v && v.contains( e.target )) ; 
      if ( !clickBln ) {
        this.setTagOptionPopListViewBln({ bln : false }) ; 
        Object.assign( this , { ...this , openClass : null }) ; 
        setTimeout(_=>{
          this.setTagAddPopWrapViewBln({ bln : false }) ; 
        } , 250 ) ;         
      } 
    } , 

    tagListHandler () {
      this.setTagOptionPopListViewBln({ bln : true }) ; 
    } , 
    
  } , 
}
</script>

<style lang="scss" scoped>
  .tagAddPopWrap {
    --btn-size: 32px; 
    position: fixed; 
    // left: calc( 50% - var( --btn-size ) / 2 ) ; 
    // top: calc( 50% - var( --btn-size ) / 2 ) ; 
    z-index: 10; 
    visibility: hidden;    

    .addBtn {
      --icon-width: 12px; 
      --icon-height: 2px; 

      &::before , &::after {
        content: ''; 
        display: flex; 
        background-color: $white; 
        position: absolute; 
      }
      &::before {
        width: var( --icon-width ); 
        height: var( --icon-height ); 
        left: calc( 50% - var( --icon-width ) / 2 );
        top: calc( 50% - var( --icon-height ) / 2 );
      } 
      &::after {
        height: var( --icon-width ); 
        width: var( --icon-height ); 
        left: calc( 50% - var( --icon-height ) / 2 );
        top: calc( 50% - var( --icon-width ) / 2 );
      } 

      width: var( --btn-size ); 
      height: var( --btn-size ); 
      background-color: $gray-3; 
      border-radius: 50%; 
      box-shadow: 0px 4px var( --default-gap ) rgba(91, 91, 91, 0.3); 
      align-items: center; 
      justify-content: center; 
      display: flex; 
      cursor: pointer; 

      transform: scale( 0 ) rotate( 0deg ); 
      transition-property: transform; 
      transition-duration: 0.25s; 
      transition-timing-function: cubic-bezier(0.18, 0.89, 0.17, 1.34);

      &.open {
        transform: scale( 1 ) rotate( 0deg ); 
      }
      &.spin {
        transform: scale( 1 ) rotate( 225deg ); 
      }
    } // end of addBtn 

    &.active {
      visibility: visible; 
    }
  }
</style>